import { absolutePath } from "../../absolutePath";

export const accessGroupMembers = {
  manage: (id: number) =>
    absolutePath(`admin/access_groups/${id}/community_members/manage`),
};
